module.exports = __webpack_public_path__ + "img/31_24.2b7e63e1.png";